import { canWrite } from "@hypertune/shared-internal";
import { ExpressionControlContext } from "../types";

export default function isReadOnly(context: ExpressionControlContext): boolean {
  return (
    context.readOnly || !canWrite(context.meId, context.resolvedPermissions)
  );
}
